import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";
import config from "../config";


import logger from "../utils/logger";
const debug = config.runmode.debug;

const getPagesCount = async (applicationId, accessToken) => {
  try {
    if (debug) logger.log("Pobieranie liczby stron świadectwa.");
    const response = await axios.get(
      ApiHost + `/certificate/count_pages/` + applicationId,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      return response.data.Count;
    }
    return 1;
  } catch (error) {
    logger.error("Błąd podczas pobierania liczby stron świadectwa: ", error);
    return 0;
  }
};

const getPagesCountApplication = async (applicationId, accessToken) => {
  try {
    if (debug) logger.log("Pobieranie liczby stron wniosku.");
    const response = await axios.get(
      ApiHost + `/certificate/count_pages_application/` + applicationId,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.status === 200) {
      return response.data.Count;
    }
    return 1;
  } catch (error) {
    logger.error("Błąd podczas pobierania liczby stron świadectwa: ", error);
    return 0;
  }
};

const downloadApplicationPackage = async (
  applicationId,
  accessToken,
  applicationNumber,
  merged = false,
) => {
  const response = await axios.get(
    ApiHost +
      `/certificate/application_package/` +
      applicationId +
      (merged ? "?merged=true" : ""),
    {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  const downloadUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  const contentDisposition = response.headers["content-disposition"] || "";
  const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  link.href = downloadUrl;
  link.download = fileNameMatch
    ? fileNameMatch[1]
    : `${applicationNumber || applicationId}${merged ? "-polaczone" : ""}.zip`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};

const downloadMergedApplicationPackage = async (
  applicationId,
  accessToken,
  applicationNumber,
) =>
  downloadApplicationPackage(
    applicationId,
    accessToken,
    applicationNumber,
    true,
  );

export {
  downloadApplicationPackage,
  downloadMergedApplicationPackage,
  getPagesCount,
  getPagesCountApplication,
};


